import { Exclude, Expose, Type } from 'class-transformer';
import { IsOptional, IsString, ValidateNested } from 'class-validator';
import { InviterInfo, TeamInviteInfo } from '..';

@Exclude()
export class InviterInfoDto implements InviterInfo {
  @Expose()
  @IsString()
  @IsOptional()
  name: string;

  @Expose()
  @IsString()
  email: string;
}

@Exclude()
export class TeamInviteInfoDto implements TeamInviteInfo {
  @Expose()
  @IsString()
  teamName: string;

  @Expose()
  @Type(() => InviterInfoDto)
  @ValidateNested()
  inviterInfo: InviterInfoDto;

  @Expose()
  @IsString()
  @IsOptional()
  inviteToken: string;

  @Expose()
  invitedAt: Date;
}
